exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "select{border:none}select:focus{outline:none}.select-wrapper{background:#fff;border:2px solid #fff;border-radius:0;box-shadow:0 0 4px rgba(0,0,0,.2)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-7a6f4130!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/custom/inputs/Select.vue
// module id = 13
// module chunks = 0